import { useEffect } from 'react';

/**
 * Real height of the fixed app bar (demo banner + header), set by
 * DashboardTemplate on the edit page and read by pages/edit.tsx. The editor
 * used to assume a 56px header; with the demo banner above it the page grew
 * taller than the viewport and everything under the editor needed a scroll.
 */
export const APP_BAR_HEIGHT_VAR = '--app-bar-height';

/** Editor viewport: the visible area below the app bar (dvh where supported, so mobile browser bars do not push it off screen). */
export const EDITOR_VIEWPORT_HEIGHT = {
  height: `calc(100vh - var(${APP_BAR_HEIGHT_VAR}, 56px))`,
  '@supports (height: 100dvh)': {
    height: `calc(100dvh - var(${APP_BAR_HEIGHT_VAR}, 56px))`,
  },
} as const;

export const useReportAppBarHeight = (ref: React.RefObject<HTMLElement>, active: boolean) => {
  useEffect(() => {
    const el = ref.current;
    const root = document.documentElement;
    if (!el || !active) return undefined;
    const report = () => root.style.setProperty(APP_BAR_HEIGHT_VAR, `${el.offsetHeight}px`);
    report();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(report) : null;
    observer?.observe(el);
    return () => {
      observer?.disconnect();
      root.style.removeProperty(APP_BAR_HEIGHT_VAR);
    };
  }, [ref, active]);
};
